import { useStaticQuery, graphql } from "gatsby"

export const useTypography = () => {
  const { groups } = useStaticQuery(graphql`
    query TYPOGRAPHY {
      groups: allSanitySettingTypography {
        edges {
          node {
            dprimary_button {
              font_family
              font_size
              letter_spacing
              line_height
            }
            dsecondary_button {
              font_family
              font_size
              letter_spacing
              line_height
            }
            secondary_button_small {
              font_family
              font_size
              letter_spacing
              line_height
            }
            menu_level_1 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            menu_level_2 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            hero_text {
              font_family
              font_size
              letter_spacing
              line_height
            }
            hero_sub_text {
              font_family
              font_size
              letter_spacing
              line_height
            }
            heading_1 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            heading_2 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            heading_3 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            heading_4 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            heading_5 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            heading_6 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            footer_heading {
              font_family
              font_size
              letter_spacing
              line_height
            }
            footer_menu {
              font_family
              font_size
              letter_spacing
              line_height
            }
            title_reqular {
              font_family
              font_size
              letter_spacing
              line_height
            }
            body_regular {
              font_family
              font_size
              letter_spacing
              line_height
            }
            title_small {
              font_family
              font_size
              letter_spacing
              line_height
            }
            body_highlight {
              font_family
              font_size
              line_height
            }
            title_extra_small {
              font_family
              font_size
              letter_spacing
              line_height
            }
            body_small {
              font_family
              font_size
              letter_spacing
              line_height
            }
            body_small_highlight {
              font_family
              font_size
              letter_spacing
              line_height
            }
            body_extra_small {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mhero_text {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mhero_sub_text {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mheading_1 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mheading_2 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mheading_3 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mheading_4 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mheading_5 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mheading_6 {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mfooter_heading {
              font_family
              font_size
              letter_spacing
              line_height
            }
            mfooter_menu {
              font_family
              font_size
              letter_spacing
              line_height
            }
          }
        }
      }
    }
  `)

  const items = groups?.edges?.map(({ node }) => node) || []
  return {
    getTypography: items[0],
  }
}
